/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'
import manaQuestions from 'images/coin-pages/questions/mana.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const manaPage: ICoinPageData = {
  title: 'coin_651',
  description: 'coin_652',
  // description:
  //   'Borrow Decentraland against Stablecoins.' +
  //   ` Get a stablecoin loan using your MANA coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, locale, replacePlaceholders) => (
    <>
      <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'MANA' }) }} />
      {locale === 'en' && ` - ${t('lend')} Decentraland (MANA)`}
    </>
  ),
  questionsBlock: {
    image: manaQuestions,
    questions: [
      {
        title: 'coin_653',
        answer: 'coin_654',
      },
      {
        title: 'coin_655',
        answer: 'coin_656',
      },
      {
        title: 'coin_657',
        answer: 'coin_658',
      },
      {
        title: 'coin_659',
        answer: 'coin_660',
      },
      {
        title: 'coin_661',
        answer: 'coin_662',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Decentraland (MANA)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_663',
        text: ['coin_667'],
      },
      {
        title: 'coin_664',
        text: ['coin_668'],
      },
      {
        title: 'coin_665',
        text: ['coin_669', 'coin_670', 'coin_671', 'coin_672', 'coin_673'],
      },
      {
        title: 'coin_666',
        text: ['coin_674', 'coin_675', 'coin_676', 'coin_677', 'coin_678'],
      },
    ],
    ...commonLearnMoreData('Decentraland (MANA)'),
  },
}
